import * as HERBUI from 'react-bootstrap';
import { isEmpty } from './Functions';
import { FiHome } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
const LoginHeader = () => {
    const history = useHistory();

    const userName = localStorage.getItem('userName');
    const getLoginName = localStorage.getItem("loginname");
    const getLoginSurName = localStorage.getItem("loginsurname");
    // Normalize to empty string if null/undefined
    const loginName = getLoginName?.trim() || "";
    const loginSurName = getLoginSurName?.trim() || "";
    // Check for valid userName
    const parsedUserName = (userName && userName !== "undefined") ? JSON.parse(userName) : "";
    const displayName = localStorage.getItem('displayName');

    function goToHome() {
        history.push('/dashboard')
    }

    return (
        <>
            <HERBUI.Container fluid>
                <HERBUI.Row>
                    <HERBUI.Navbar collapseOnSelect expand="lg" fixed="top" className="HERB-Top-Nav" style={{ posistion: "fixed", top: "0px" }} >
                        <HERBUI.Navbar.Brand href="#home">
                            <img
                                src="img/herb.svg"
                                width="250"
                                height="45"
                                className="d-inline-block align-top"
                                alt="NIDHI"
                            />
                        </HERBUI.Navbar.Brand>
                        <HERBUI.Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <HERBUI.Navbar.Collapse id="responsive-navbar-nav">
                            <HERBUI.Nav className="me-auto"></HERBUI.Nav>
                            <HERBUI.Nav>
                                <HERBUI.Nav.Link onClick={goToHome} className="icon-size-header"><FiHome /></HERBUI.Nav.Link>
                                <HERBUI.NavDropdown
                                    className="header-dropdown-setting"
                                    title={
                                        (isEmpty(loginName) && isEmpty(loginSurName) && !isEmpty(displayName) && !isEmpty(parsedUserName))
                                            ? (
                                                <b>
                                                    <span>Welcome:</span>&nbsp;
                                                    {displayName} ({parsedUserName})
                                                </b>
                                            )
                                            : (
                                                <b>
                                                    <span>Welcome:</span>&nbsp;
                                                    {(loginName || "").trim()} {(loginSurName || "").trim()} ({parsedUserName || ""})
                                                </b>
                                            )
                                    }
                                    id="basic-nav-dropdown"
                                >

                                    {/* <HERBUI.NavDropdown.Item onClick={ChangePassword}>
                               <BiLock size={25} onClick={ChangePassword} /> Change Password
                             </HERBUI.NavDropdown.Item>
                             <HERBUI.NavDropdown.Item onClick={() => handleLogOut()}>
                               <FiPower size={23} onClick={() => handleLogOut()} /> Sign Out
                             </HERBUI.NavDropdown.Item> */}
                                </HERBUI.NavDropdown>
                            </HERBUI.Nav>
                        </HERBUI.Navbar.Collapse>
                    </HERBUI.Navbar>
                </HERBUI.Row>
            </HERBUI.Container>
        </>
    )
}
export default LoginHeader;